import { configureStore } from "@reduxjs/toolkit";
import patientsReducer from './ReduxSlices/Patients/patientSlice';
import patientQueueReducer from './ReduxSlices/Patients/patientQueueSlice';
import billReducer from './ReduxSlices/Bills/billSlice';
import labTestReducer from './ReduxSlices/LabTests/labTestSlice';
import prescriptionReducer from './ReduxSlices/Prescriptions/prescriptionSlice';
import dispensationReducer from './ReduxSlices/Prescriptions/dispensationLogSlice';
import prescriptionQueueReducer from './ReduxSlices/Prescriptions/prescriptionQueueSlice';
import inventoryReducer from './ReduxSlices/Inventories/inventorySlice';
import appointmentReducer from './ReduxSlices/Appointments/appointmentsSlice';
import labTestServiceReducer from './ReduxSlices/Admin/labTestServiceSlice';
import userReducer from "./ReduxSlices/Admin/userSlice";
import consultationServiceReducer from "./ReduxSlices/Admin/consultationServiceSlice";
import AdminDashboardReducer from "./ReduxSlices/Admin/dashboardSlice";
import LabRequestsReducer from "./ReduxSlices/LabRequests/labRequests";
import organizationReducer from "./ReduxSlices/Admin/organizationDataSlice";
import auditReducer from "./ReduxSlices/AuditEvents/AuditEventSlice";
import labSupplyReducer from "./ReduxSlices/LabSupplies/labSupplySlice";

export const store = configureStore({
    reducer: {
        patients: patientsReducer,
        patientQueue: patientQueueReducer,
        bills: billReducer,
        labTests:labTestReducer,
        prescriptions: prescriptionReducer,
        dispensationLogs: dispensationReducer,
        prescriptionQueue: prescriptionQueueReducer,
        inventories: inventoryReducer,
        appointments: appointmentReducer,
        labServices: labTestServiceReducer,
        users: userReducer,
        consultations: consultationServiceReducer,
        dashboard: AdminDashboardReducer,
        labRequests:LabRequestsReducer,
        organization : organizationReducer,
        audit: auditReducer,
        labSupplies: labSupplyReducer
    },
});